// Class: openfl.filters._GlowFilter.InvertAlphaShader

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $hxEnums = require("./../../../hxEnums_stub").default;
var $import = require("./../../../import_stub").default;
var $extend = require("./../../../extend_stub").default;
function openfl_filters_BitmapFilterShader() {return require("./../../../openfl/filters/BitmapFilterShader");}

// Constructor

var InvertAlphaShader = function() {
	if(this.__glFragmentSource == null) {
		this.__glFragmentSource = "\n\t\tuniform sampler2D openfl_Texture;\n\t\tvarying vec2 vTexCoord;\n\n\t\tvoid main(void) {\n\t\t\tvec4 texel = texture2D(openfl_Texture, vTexCoord);\n\t\t\tgl_FragColor = vec4(texel.rgb, 1.0 - texel.a);\n\t\t}\n\t";
	}
	if(this.__glVertexSource == null) {
		this.__glVertexSource = "\n\t\tattribute vec4 openfl_Position;\n\t\tattribute vec2 openfl_TextureCoord;\n\t\tuniform mat4 openfl_Matrix;\n\t\tvarying vec2 vTexCoord;\n\n\t\tvoid main(void) {\n\t\t\tgl_Position = openfl_Matrix * openfl_Position;\n\t\t\tvTexCoord = openfl_TextureCoord;\n\t\t}\n\t";
	}
	(openfl_filters_BitmapFilterShader().default).call(this);
	this.__isGenerated = true;
	this.__initGL();
}

// Meta

InvertAlphaShader.__name__ = "openfl.filters._GlowFilter.InvertAlphaShader";
InvertAlphaShader.__isInterface__ = false;
InvertAlphaShader.__super__ = (openfl_filters_BitmapFilterShader().default);
InvertAlphaShader.prototype = $extend((openfl_filters_BitmapFilterShader().default).prototype, {
	
});
InvertAlphaShader.prototype.__class__ = InvertAlphaShader.prototype.constructor = $hxClasses["openfl.filters._GlowFilter.InvertAlphaShader"] = InvertAlphaShader;

// Init



// Statics




// Export

exports.default = InvertAlphaShader;